import { request } from "../../api/api"

export const getTermsAndConsition = () => {
    return request.get("/terms-and-conditions/")
}
export const getTermsAndConsitionPolicies = () => {
    return request.get('/terms-and-conditions/');
};
export const updateTermsAndConsition = (data) => {
    return request.post(`/terms-and-conditions/`,data);
};